export default {
  loading: true,
  orders: [],
  entityCount: 0,
  page: 0,
  pageSize: 10,
  filters: {},
}
